import React, { useEffect } from "react";
import ViewMaster from "../../Components/ViewMaster/ViewMaster";

function TermsAndConditions() {
  useEffect(() => {
    document.title = "Zesty games | Privacy Policy & Terms of Use";
  }, []);
  return (
    <>
      <div>
        <div className="bgContent" style={{ "background-color": "#ffffff" }}>
          <div className="container py-4 text-white fs-20 txblack">
            <div className="txblack">
              <h4 className="DescriptionHeading">
                <strong>Terms of Use for ZestyGame.com</strong>
              </h4>
              <div>
                <p>
                  <strong>Introduction:</strong>
                </p>

                <p>
                  Hello, and welcome to ZestyGame.com. By accessing or using our
                  website, you are agreeing to comply with these Terms of Use.
                  Please do not use our site if you disagree with any part of
                  the terms. We reserve the right to alter these conditions from
                  time to time, and any changes will take effect immediately
                  after they're posted. Continued use of our site following
                  updates indicates your agreement with the updated conditions.
                </p>

                <p>
                  <strong>Eligibility:</strong>
                </p>

                <p>
                  The consent of a parent or legal guardian is required to use
                  our site and services. You confirm that you and your guardian
                  understand and agree to these terms by using ZestyGame.com.
                </p>

                <p>
                  <strong>Acceptance of Terms:</strong>
                </p>

                <p>
                  Your use of ZestyGame.com indicates your acceptance of these
                  Terms of Use, which may be updated without notice. Please
                  visit the 'Terms of Use' section on our website to review the
                  latest version.
                </p>

                <p>
                  <strong>Trademarks and Copyrights:</strong>
                </p>

                <p>
                  Unless otherwise stated, ZestyGame.com owns all brand names
                  and logos associated with its name. The use of these
                  trademarks without authorization is strictly forbidden. Other
                  brand names and logos mentioned on our site belong to their
                  respective owners.
                </p>

                <p>
                  <strong>Privacy and Data Protection:</strong>
                </p>

                <p>
                  Your personal information will be handled according to our
                  Privacy Policy. Please take a look at it to understand how we
                  manage your data.
                </p>

                <p>
                  <strong>Permitted Use:</strong>
                </p>

                <p>
                  Our services are meant for personal, non-commercial use only.
                  Any content obtained from ZestyGame.com may not be altered,
                  distributed, or sold without our prior consent.
                </p>

                <p>
                  <strong>Limitation of Liability:</strong>
                </p>

                <p>
                  The services provided by ZestyGame.com are provided as is and
                  as available. No warranties are made about the operation or
                  content of our site. We are not liable for any damages that
                  result from your use of our services.
                </p>

                <p>
                  <strong>Disclaimer of Guarantees and Support:</strong>
                </p>

                <p>
                  We are not obligated to provide support, and we do not
                  guarantee the accuracy or reliability of our services.
                </p>

                <p>
                  <strong>Prohibited Use:</strong>
                </p>

                <p>
                  You agree not to use ZestyGame.com in a way that could harm
                  others or disrupt our services. Sending unsolicited
                  communications or infringing on others' rights are prohibited.
                </p>

                <p>
                  <strong>Governing Law:</strong>
                </p>

                <p>
                  The laws of India govern these usage guidelines. If any part
                  of these terms is found to be invalid, the remaining
                  provisions will still be in effect.
                </p>

                <p>
                  <strong>Unsolicited Submissions:</strong>
                </p>

                <p>
                  Ideas or materials that are not requested are not accepted.
                  We're not responsible for any resemblances between your
                  content and ours if you send it to us.
                </p>

                <p>
                  By using ZestyGame.com, you agree to these Terms of Use. Thank
                  you for visiting our gaming community!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewMaster(TermsAndConditions);
